import styled from "styled-components";

import { colors, sizes } from "@/styles/variables";

export const Container = styled.div`
  background: ${colors.paleYellow} -8% 50% no-repeat;
  background-size: cover;
  padding: 3rem 0 0;
  overflow-y: auto;
`;

export const OverlayLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  z-index: 9999;
`;

export const LayoutContent = styled.div`
  max-width: ${sizes.siteMaxWidth}px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

export const LogoWrapper = styled.div`
  text-align: center;
  margin: 0 0 2rem;
`;
export const MatchError = styled.div`
  color: red;
  font-size: 14px;
  margin-bottom: 10px;
`;
export const PasswordWrapper = styled.div`
  width: 100%;
  position: relative;

  .password_icon {
    position: absolute;
    top: 40px;
    right: 10px;
    z-index: 2;
  }
`;

export const ReceiveText = styled.div`
  font-weight: bold;
  margin: 20px 56px;
  text-align: center;
`;
export const Title = styled.h1`
  font: italic normal 2rem/40px "Meta Serif OT";
  text-align: center;
  padding: 0 1.5rem;
  margin: 0 0 2rem;

  span {
    font: normal 2px "Arial";
    font-size: 18px;
    font-weight: 500;
  }
`;
